import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import styles from './WalletConfirmed.module.css'

const WalletConfirmed: FC<{ status: 'confirmed' | 'unconfirmed'; className?: string }> = (
	props
): ReactElement => {
	return (
		<div className={styles.root}>
			<div
				className={classNames(
					{ [(props.className as any)]: !!props.className },
					{ [styles.unconfirmed]: props.status === 'unconfirmed' },
					styles.circle
				)}
			/>
		</div>
	)
}

export default WalletConfirmed
